import { render, staticRenderFns } from "./product-filter-loader.vue?vue&type=template&id=678191de&scoped=true"
import script from "./product-filter-loader.vue?vue&type=script&lang=js"
export * from "./product-filter-loader.vue?vue&type=script&lang=js"
import style0 from "./product-filter-loader.vue?vue&type=style&index=0&id=678191de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678191de",
  null
  
)

export default component.exports